import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import Loading from "./Loading";
import "../css/WaitingListStatus.css";

const formatDateRange = (start, end) => {
  const fmt = (d) =>
    d
      ? new Date(d).toLocaleString("pl-PL", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "—";

  return `${fmt(start)} - ${fmt(end)}`;
};

const WaitingListStatus = () => {
  const { reservationGuid } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        setIsLoading(true);
        setNotFound(false);
        const res = await api.getWaitingListStatus(reservationGuid);
        setData(res);
      } catch (err) {
        if (err?.response?.status === 404) {
          setNotFound(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchStatus();
  }, [reservationGuid]);

  if (isLoading) return <Loading />;

  if (notFound || !data) {
    return (
      <div className="mail-preview-body">
        <div className="content">
          <div className="center">
            <img className="logo" src="/logo.png" alt="Logo" />
          </div>

          <p className="greeting">
            Cześć <strong>😊</strong>
          </p>

          <p>
            Ta rezerwacja nie istnieje lub nie znajduje się obecnie na{" "}
            <span className="status">liście rezerwowej</span>.
          </p>

          <p>
            Aktualnie zaplanowane wycieczki znajdziesz po kliknięciu przycisku{" "}
            <i>Powrót do strony głównej</i> w prawym górnym rogu.
          </p>
        </div>
      </div>
    );
  }

  const reservationCode = data.reservationCode ?? data.registrationCode ?? "—";
  const tripName = data.tripName ?? "—";
  const variantName = data.variantName ?? "—";
  const dateRange = formatDateRange(data.startDate, data.endDate);

  return (
    <div className="mail-preview-body">
      <div className="content">
        <div className="center">
          <img className="logo" src="/logo.png" alt="Logo" />
        </div>

        <p className="greeting">
          Cześć <strong>😊</strong>
        </p>

        <p>
          Twoja rezerwacja znajduje się obecnie na{" "}
          <span className="status">liście rezerwowej</span>. Poniżej znajdziesz
          aktualne informacje o rezerwacji, miejsce Twojej rezerwacji w kolejce
          oraz liczbę osób, które znajdują się przed nią.
        </p>

        <table className="info-table">
          <tbody>
            <tr>
              <td>Numer rezerwacji</td>
              <td className="value">{reservationCode}</td>
            </tr>
            <tr>
              <td>Nazwa wydarzenia</td>
              <td className="value">{tripName}</td>
            </tr>
            <tr>
              <td>Wariant</td>
              <td className="value">{variantName}</td>
            </tr>
            <tr>
              <td>Data wydarzenia</td>
              <td className="value">{dateRange}</td>
            </tr>
            <tr>
              <td>Status rezerwacji</td>
              <td className="status">Lista rezerwowa</td>
            </tr>
            <tr>
              <td>Pozycja rezerwacji na liście</td>
              <td className="value">{data.reservationPosition ?? "—"}</td>
            </tr>
            {data.peopleBeforeCount > 0 && (
              <tr>
                <td>Liczba osób przed rezerwacją</td>
                <td className="value">{data.peopleBeforeCount}</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="footer">
          {data.peopleBeforeCount > 0 && (
            <p>
              <strong>Jak to rozumieć?</strong>
              <br />
              Pozycja rezerwacji oznacza miejsce Twojej rezerwacji w kolejności
              zgłoszeń na liście rezerwowej. Liczba osób przed Twoją rezerwacją
              uwzględnia natomiast to, że wcześniejsze rezerwacje mogą obejmować
              więcej niż jedną osobę.
            </p>
          )}

          <p>
            <strong>Co dalej?</strong>
            <br />
            Nawet odległe miejsce na liście rezerwowej nie oznacza jeszcze, że
            udział w wyjeździe jest niemożliwy. Sytuacja bywa dynamiczna —
            szczególnie w pierwszej fazie zapisów, ale również później, gdy
            część osób rezygnuje z różnych przyczyn.
          </p>

          <p>
            Osoby koordynujące na bieżąco reagują na zwalniające się miejsca i
            przydzielają je kolejnym osobom z listy rezerwowej. O zmianie
            statusu rezerwacji zostaniesz poinformowanx mailowo, a w
            szczególnych przypadkach również telefonicznie.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WaitingListStatus;